import VerifyPhoneAndCnpjRequest from '../entities/VerifyPhoneAndCnpjRequest'
import IVerifyPhoneAndCnpjResponse from '../entities/VerifyPhoneAndCnpjResponse'
import { IUserRepository } from '../repositories/IUserRepository'

export interface IVerifyPhoneAndCnpj {
  execute(
    params: VerifyPhoneAndCnpjRequest,
  ): Promise<IVerifyPhoneAndCnpjResponse>
}

export default class VerifyPhoneAndCnpjImpl implements IVerifyPhoneAndCnpj {
  constructor(private readonly userRepository: IUserRepository) {}

  public async execute(
    params: VerifyPhoneAndCnpjRequest,
  ): Promise<IVerifyPhoneAndCnpjResponse> {
    const response = await this.userRepository.verifyPhoneAndCnpj(params)

    return response
  }
}
